import React, { useState } from 'react';
import FileTable from './FileTable';

const DISK_OPTIONS = [
  { label: '1TB', value: 1000 },
  { label: '2TB', value: 2000 },
  { label: '4TB', value: 4000 },
  { label: '8TB', value: 8000 },
  { label: '10TB', value: 10000 },
  { label: '12TB', value: 12000 },
  { label: '14TB', value: 14000 },
  { label: '18TB', value: 18000 },
  { label: '20TB', value: 20000 },
];

const TOOL_OPTIONS = [
  { label: 'MadMax', value: 'madmax' },
  { label: 'BladeBit', value: 'bladebit' },
];

const COMPRESSION_OPTIONS = {
  madmax: [
    { label: 'C0', value: 'C0' },
    { label: 'C1', value: 'C1' },
    { label: 'C2', value: 'C2' },
    { label: 'C3', value: 'C3' },
    { label: 'C4', value: 'C4' },
    { label: 'C5', value: 'C5' },
    { label: 'C6', value: 'C6' },
    { label: 'C7', value: 'C7' },
    { label: 'C8', value: 'C8' },
    { label: 'C9', value: 'C9' },
  ],
  bladebit: [
    { label: 'C0', value: 'C0' },
    { label: 'C1', value: 'C1' },
    { label: 'C2', value: 'C2' },
    { label: 'C3', value: 'C3' },
    { label: 'C4', value: 'C4' },
    { label: 'C5', value: 'C5' },
    { label: 'C6', value: 'C6' },
    { label: 'C7', value: 'C7' },
  ],
};

export default function App() {
  const [textToCopy, setTextToCopy] = useState(
    'xch1qscs5zknjtj0u56ey0fyl78junyw5hquza4hrtglevsv4vgs6tvqlkestn'
  );

  return (
    <div className="container-fluid text-center">
      <h1 className="mt-3 text-success">Chia Plot Compression Guide</h1>

      <FileTable />

      <footer className="position-relative bottom-0 start-50 translate-middle-x mt-3">
        <strong style={{ maxWidth: '250px' }} className="text-warning">
          Like this tool? I appreciate if you donate to support my efforts.
        </strong>
        <p
          onClick={() => navigator.clipboard.writeText(textToCopy)}
          style={{ cursor: 'pointer' }}
        >
          <button
            className="btn"
            onClick={() => navigator.clipboard.writeText(textToCopy)}
          >
            <i className="bi bi-clipboard"></i>
          </button>
          {textToCopy.substring(0, 6) + '...' + textToCopy.substring(58, 62)}
        </p>
      </footer>
      <div className="footer"></div>
    </div>
  );
}
